
import Divider from 'vux/src/components/divider/index.vue'


export default {
components: {
Divider
}
}



// WEBPACK FOOTER //
// ./src/components/NotFound.vue